import React, { useState } from 'react';
import './Instrument.css';

function PianoInstrument({ onAddNote }) {
  const [selectedNote, setSelectedNote] = useState(null);

  // 钢琴：十进制35-70 (36音，3个八度) (meow: 12-14)
  // 低音区: 35-46 (0x23-0x2E, 12音), 中音区: 47-58 (0x2F-0x3A, 12音), 高音区: 59-70 (0x3B-0x46, 12音)
  const pianoNotes = [
    // 低音区 (meow: 12) - 十进制35-46 (0x23-0x2E, 12音)
    { name: '低1', song: '23', meow: '1', type: 'white', jianpu: '1', octave: 'low' },
    { name: '低#1', song: '24', meow: '2', type: 'black', jianpu: '#1', octave: 'low' },
    { name: '低2', song: '25', meow: '3', type: 'white', jianpu: '2', octave: 'low' },
    { name: '低#2', song: '26', meow: '4', type: 'black', jianpu: '#2', octave: 'low' },
    { name: '低3', song: '27', meow: '5', type: 'white', jianpu: '3', octave: 'low' },
    { name: '低4', song: '28', meow: '6', type: 'white', jianpu: '4', octave: 'low' },
    { name: '低#4', song: '29', meow: '7', type: 'black', jianpu: '#4', octave: 'low' },
    { name: '低5', song: '2A', meow: '8', type: 'white', jianpu: '5', octave: 'low' },
    { name: '低#5', song: '2B', meow: '1', type: 'black', jianpu: '#5', octave: 'low' },
    { name: '低6', song: '2C', meow: '2', type: 'white', jianpu: '6', octave: 'low' },
    { name: '低#6', song: '2D', meow: '3', type: 'black', jianpu: '#6', octave: 'low' },
    { name: '低7', song: '2E', meow: '4', type: 'white', jianpu: '7', octave: 'low' },
    
    // 中音区 (meow: 13) - 十进制47-58 (0x2F-0x3A, 12音)
    { name: '中1', song: '2F', meow: '5', type: 'white', jianpu: '1', octave: 'middle' },
    { name: '中#1', song: '30', meow: '6', type: 'black', jianpu: '#1', octave: 'middle' },
    { name: '中2', song: '31', meow: '7', type: 'white', jianpu: '2', octave: 'middle' },
    { name: '中#2', song: '32', meow: '8', type: 'black', jianpu: '#2', octave: 'middle' },
    { name: '中3', song: '33', meow: '1', type: 'white', jianpu: '3', octave: 'middle' },
    { name: '中4', song: '34', meow: '2', type: 'white', jianpu: '4', octave: 'middle' },
    { name: '中#4', song: '35', meow: '3', type: 'black', jianpu: '#4', octave: 'middle' },
    { name: '中5', song: '36', meow: '4', type: 'white', jianpu: '5', octave: 'middle' },
    { name: '中#5', song: '37', meow: '5', type: 'black', jianpu: '#5', octave: 'middle' },
    { name: '中6', song: '38', meow: '6', type: 'white', jianpu: '6', octave: 'middle' },
    { name: '中#6', song: '39', meow: '7', type: 'black', jianpu: '#6', octave: 'middle' },
    { name: '中7', song: '3A', meow: '8', type: 'white', jianpu: '7', octave: 'middle' },
    
    // 高音区 (meow: 14) - 十进制59-70 (0x3B-0x46, 12音)
    { name: '高1', song: '3B', meow: '1', type: 'white', jianpu: '1', octave: 'high' },
    { name: '高#1', song: '3C', meow: '2', type: 'black', jianpu: '#1', octave: 'high' },
    { name: '高2', song: '3D', meow: '3', type: 'white', jianpu: '2', octave: 'high' },
    { name: '高#2', song: '3E', meow: '4', type: 'black', jianpu: '#2', octave: 'high' },
    { name: '高3', song: '3F', meow: '5', type: 'white', jianpu: '3', octave: 'high' },
    { name: '高4', song: '40', meow: '6', type: 'white', jianpu: '4', octave: 'high' },
    { name: '高#4', song: '41', meow: '7', type: 'black', jianpu: '#4', octave: 'high' },
    { name: '高5', song: '42', meow: '8', type: 'white', jianpu: '5', octave: 'high' },
    { name: '高#5', song: '43', meow: '1', type: 'black', jianpu: '#5', octave: 'high' },
    { name: '高6', song: '44', meow: '2', type: 'white', jianpu: '6', octave: 'high' },
    { name: '高#6', song: '45', meow: '3', type: 'black', jianpu: '#6', octave: 'high' },
    { name: '高7', song: '46', meow: '4', type: 'white', jianpu: '7', octave: 'high' },
  ];

  const handleNoteClick = (note) => {
    setSelectedNote(note);
    // 确保 meow 值是两位16进制格式（带前导0）
    let meowHex = String(note.meow);
    if (meowHex.length === 1) {
      meowHex = `0${meowHex}`;
    }
    onAddNote(meowHex.toUpperCase(), note.song);
  };

  return (
    <div className="instrument">
      <div className="instrument-title">
        <span className="icon">🎹</span>
        <div>
          <h3>钢琴</h3>
          <p className="subtitle">35-70 (36音，3个八度)</p>
        </div>
      </div>

      <div className="piano-container">
        <div className="piano-section">
          <h4 className="section-title">低音区 (35-46, 12音)</h4>
          <div className="piano-keys">
            {pianoNotes.slice(0, 12).map((note, index) => (
              <button
                key={index}
                className={`piano-key ${note.type} ${selectedNote?.name === note.name ? 'selected' : ''}`}
                onClick={() => handleNoteClick(note)}
              >
                <div className="piano-key-content">
                  <span className="key-jianpu">{note.jianpu}</span>
                  <span className="key-dot-low">•</span>
                </div>
              </button>
            ))}
          </div>
        </div>

        <div className="piano-section">
          <h4 className="section-title">中音区 (47-58, 12音)</h4>
          <div className="piano-keys">
            {pianoNotes.slice(12, 24).map((note, index) => (
              <button
                key={index}
                className={`piano-key ${note.type} ${selectedNote?.name === note.name ? 'selected' : ''}`}
                onClick={() => handleNoteClick(note)}
              >
                <div className="piano-key-content">
                  <span className="key-jianpu">{note.jianpu}</span>
                </div>
              </button>
            ))}
          </div>
        </div>

        <div className="piano-section">
          <h4 className="section-title">高音区 (59-70, 12音)</h4>
          <div className="piano-keys">
            {pianoNotes.slice(24, 36).map((note, index) => (
              <button
                key={index}
                className={`piano-key ${note.type} ${selectedNote?.name === note.name ? 'selected' : ''}`}
                onClick={() => handleNoteClick(note)}
              >
                <div className="piano-key-content">
                  <span className="key-dot-high">•</span>
                  <span className="key-jianpu">{note.jianpu}</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="help-text">
        <p>💡 白键为自然音，黑键为升半音</p>
      </div>
    </div>
  );
}

export default PianoInstrument;

